import React, { useState, useEffect } from 'react';
import { CButton, CCard, CCardBody, CCol, CRow, CBadge, CInput, CProgress, CProgressBar, CSpinner, CPopover, CFormGroup, CLabel } from '@coreui/react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import useSubscriptionCheck from 'src/utils/useSubscriptionCheck';
import { useDialog } from 'src/utils/DialogContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDateToMMDDYYYY } from 'src/utils/dateUtils';
import { getWeeklyReport, saveWeekly } from 'src/request/Reports';
import ModalComments from 'src/reusable/modal-comment/ModalComments';
import { DownloadReportWeekly, AccomplishmentComputation, WeightedPercentageComputation, GetProjectTimeline } from 'src/request/Projects';
import DateRangePickerInput from 'src/reusable/DateRangePickerInput';
import { formatDateString, getSundayOfWeek, getSaturdayOfWeek } from 'src/reusable/dateRangeUtils';
import { findAllowedFeature } from 'src/utils/findAllowedFeature';
import { useHistory } from 'react-router-dom';
import Loading from '../aimhi-widgets/Loading';
import { showError } from 'src/utils/swalError'; import { preventInvalidKeys, blurOnWheel, preventInvalidPaste } from 'src/reusable/inputSettings';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';

const getDefaultDateRange = () => {
  const today = new Date();
  const start = getSundayOfWeek(today);
  const end = getSaturdayOfWeek(today);
  return `${formatDateString(start)} - ${formatDateString(end)}`;
};

const Weekly = (props) => {
  const features = useSelector((state) => state.ui.features);
  const [weeklyReport, setWeeklyReport] = useState([]);
  const [date, setDate] = useState(getDefaultDateRange());
  const [toggle, setToggle] = useState([]);
  const [projectId, setprojectId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloadableReportAllowed, setIsDownloadableReportAllowed] = useState(false);
  const history = useHistory();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isModalCommentOpen, setIsModalCommentOpen] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [project_data, setProjectData] = useState(null);
  const { openDialog, closeDialog } = useDialog();
  const { refreshSubscription, handleSubscriptionRequest, NoCreditsLeft } = useSubscriptionCheck();

  useEffect(() => {
    if (props.id) {
      setprojectId(props.id);
      getWeekly(0);
    }
  }, [props.id]);

  useEffect(() => {
    if (props.id) {
      GetProjectTimeline(props.id)
        .then((res) => {
          if (res?.data?.project_data) {
            setProjectData(res.data.project_data);
          }
        })
        .catch((err) => {
          console.error('Error fetching project timeline:', err);
        });
    }
  }, [props.id]);

  useEffect(() => {
    if (features.length > 0) {
      setIsDownloadableReportAllowed(findAllowedFeature(features, 5));
    }
  }, [features]);

  const openModalComment = (item) => {
    setReportData(item);
    setIsModalCommentOpen(true);
  };
  const closeModalComment = () => {
    setIsModalCommentOpen(false);
    setReportData([]);
  };
  let weekly = [];
  const getWeekly = (status, dateRangeStr) => {
    setIsDataLoading(true);
    const targetDate = dateRangeStr ?? date;
    const [startDate = '', endDate = ''] = targetDate?.split(' - ').map((d) => d.trim()) ?? [];

    if (!startDate || !endDate) {
      setIsDataLoading(false);
      return;
    }

    const payload = {
      projectId: props.id,
      status,
      startDate,
      endDate,
    };

    getWeeklyReport(payload)
      .then((res) => {
        setIsDataLoading(false);
        if (res.status == 200) {
          setWeeklyReport(res.data.response.data);
          weekly = res.data.response.data;
          setDate(res.data.response.date);
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data.response,
            text: res.data.description,
            confirmButtonColor: '#23303D',
          });
        }
      })
      .catch((err) => {
        setIsDataLoading(false);
        console.error('Error fetching weekly report:', err);
      });
  };

  const saveChanges = () => {
    let arr = [...weeklyReport];
    let newArr = [];
    let hasEmptyAccomplishment = false;

    for (let i = 0; i < arr.length; i++) {
      let newItem = [];
      arr[i].date_range = date;
      arr[i].save_type = 'CW';
      for (let j = 0; j < arr[i].item.length; j++) {
        if (arr[i].item[j].edited) {
          arr[i].item[j].start_date = adjustDateFormat(arr[i].item[j].start_date);
          arr[i].item[j].end_date = adjustDateFormat(arr[i].item[j].end_date);
          arr[i].item[j].actual_start_date = adjustDateFormat(arr[i].item[j].actual_start_date);
          arr[i].item[j].actual_end_date = adjustDateFormat(arr[i].item[j].actual_end_date);
          arr[i].item[j].date_created = adjustDateFormat(arr[i].item[j].date_created);
          newItem.push(arr[i].item[j]);
        }

        if (arr[i].item[j].accomplishment_edited) {
          arr[i].item[j].status = 0;
        } else {
          arr[i].item[j].accomplishment = 0;
        }
        if (isNaN(arr[i].item[j].accomplishment) || arr[i].item[j].accomplishment === '') {
          hasEmptyAccomplishment = true;
        }
      }

      if (newItem.length > 0) {
        arr[i].item = newItem;
        newArr.push(arr[i]);
      }
    }
    if (hasEmptyAccomplishment) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Input',
        text: 'One or more accomplishments are empty. Please fill in all required fields before saving.',
        confirmButtonColor: '#23303D',
      });
      hasEmptyAccomplishment = false;
      return;
    }

    if (newArr.length > 0) {
      saveWeekly(props.id, newArr)
        .then((res) => {
          const mixpanelData = newArr.map(section => {
            const item = section.item?.[0] || {};

            return {
              work_item: item.work_item,
              psow_id: item.psow_id,
              sow_id: item.sow_id,
              start_date: item.start_date,
              end_date: item.end_date,
              actual_start_date: item.actual_start_date,
              actual_end_date: item.actual_end_date,
              project_id: props?.id,
              phase: section.phase,
              phase_id: section.phase_id,
              date_range: section.date_range,
              progress: section.progress
            };
          });

          if (res.data.status === 200) {
            mixpanelData.forEach((item) => {
              trackEvent(mixPanelEvents.SAVE_WEEKLY, {
                'Source': 'Project - Reports - Weekly',
                ...item,
              })
            })
            Swal.fire({
              icon: 'success',
              title: 'Your work has been saved!',
              showConfirmButton: false,
              timer: 1500,
            });
            getWeekly(0);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops..',
              text: res.data.error || res.data.message || 'Something went wrong',
              showConfirmButton: false,
              timer: 2500,
            });
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops..',
            text: error?.response?.data?.message || 'Something went wrong',
            showConfirmButton: false,
          });
        });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops..',
        text: 'No data to be save',
        confirmButtonColor: '#23303D',
      });
    }
  };

  const toggleShow = (value) => {
    const shownState = toggle.slice();
    const index = shownState.indexOf(value);

    if (index >= 0) {
      shownState.splice(index, 1);
      setToggle(shownState);
    } else {
      shownState.push(value);
      setToggle(shownState);
    }
  };

  const workItemChange = (e, dataIndex, itemIndex) => {
    let arr = [...weeklyReport];
    arr[dataIndex].item[itemIndex].work_item = e.target.value;

    setWeeklyReport(arr);
  };

  const adjustDateFormat = formatDateToMMDDYYYY;

  useEffect(() => {
    setprojectId(props.id);
    dateformat(props.start, props.end);
  }, []);

  const dateformat = (start, end) => {
    let a = new Date(start);
    let b = new Date(end);

    let sm = a.getMonth() + 1;
    let sd = a.getDate();
    let sy = a.getFullYear();
    let date_start = sy + '-' + sm + '-' + sd;

    let em = b.getMonth() + 1;
    let ed = b.getDate();
    let ey = b.getFullYear();
    let date_end = ey + '-' + em + '-' + ed;
  };

  const computeAccomplishment = async (payload) => {
    try {
      const result = await AccomplishmentComputation(payload);

      const updatedValue = result?.data?.value;
      if (typeof updatedValue === 'number') {
        return updatedValue;
      }
      else {
        return 0;
      }
    } catch (error) {
      console.error('Error computing status:', error);
      return 0;
    }
  };

  const changeSowProgress = async (value, Index, dataIndex, estimateMeasurement, unit) => {
    const newArr = [...weeklyReport];
    const reportData = newArr[dataIndex];
    const reportItem = reportData.item[Index];

    const computationPayload = {
      status: value,
      measurement: estimateMeasurement,
    }
    const autoAccomplishmentComputation = await computeAccomplishment(computationPayload);
    const isValid = estimateMeasurement > 0;

    const accomplishmentComputation = isValid ? Number(autoAccomplishmentComputation?.toFixed(2)) : 0;

    if (estimateMeasurement <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid input',
        text: `You cannot input your progress because the estimate measurement is ${estimateMeasurement} ${decodeURIComponent(JSON.parse(`"${unit}"`))}. Please update the estimate measurement first.`,
        confirmButtonColor: '#23303D',
        confirmButtonText: 'Update',
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          history.push(`/project/${projectId}/estimate?sow_id=${newArr[dataIndex].item[Index].sow_id}&psow_id=${newArr[dataIndex].item[Index].psow_id}`);
        }
      });
    } else {
      reportItem.status = value;
      reportItem.accomplishment_edited = false;
      reportItem.edited = true;
      reportItem.accomplishment = accomplishmentComputation;
      if (reportItem.status) setWeeklyReport(newArr);
    }
  };

  const changestartdate = (value, Index, dataIndex, category) => {
    const newArr = [...weeklyReport];
    if (category === 'target') {
      newArr[dataIndex].item[Index].StartDate = value;
    } else if (category === 'actual') {
      newArr[dataIndex].item[Index].actual_start_date = value;
    }
    newArr[dataIndex].item[Index].edited = true;
    setWeeklyReport(newArr);
  };

  const changeenddate = (value, Index, dataIndex, category) => {
    const newArr = [...weeklyReport];
    if (category === 'target') {
      newArr[dataIndex].item[Index].EndDate = value;
    } else if (category === 'actual') {
      newArr[dataIndex].item[Index].actual_end_date = value;
    }

    newArr[dataIndex].item[Index].edited = true;
    setWeeklyReport(newArr);
  };

  const validateInput = (enteredValue) => {
    const isValid = enteredValue === '' || (/^\d*\.?\d*$/.test(enteredValue) && parseFloat(enteredValue) >= 0);
    return isValid;
  };


  const computeStatus = async (payload) => {
    try {
      const result = await WeightedPercentageComputation(payload);

      const updatedValue = result?.data?.value;
      if (typeof updatedValue === 'number') {
        return updatedValue;
      }
      else {
        return 0;
      }
    } catch (error) {
      console.error('Error computing status:', error);
      return 0;
    }
  };
  const changeAccomplishment = async (value, estimateMeasurement, unit, Index, dataIndex) => {
    const newArr = [...weeklyReport];
    const reportData = newArr[dataIndex];
    const currentItem = reportData.item[Index];
    const parsedValue = parseFloat(value);
    const valueGreaterThanEstimate = parsedValue > parseFloat(estimateMeasurement);

    let updatedAccomplishment = currentItem.accomplishment;
    let statusComputation = currentItem.status;

    if (!estimateMeasurement || valueGreaterThanEstimate) {
      if (estimateMeasurement <= 0) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid input',
          text: `You cannot input your accomplishment because the estimate measurement is ${estimateMeasurement} ${decodeURIComponent(JSON.parse(`"${unit}"`))}. Please update the estimate measurement first.`,
          confirmButtonColor: '#23303D',
          confirmButtonText: 'Update',
          showCancelButton: true,
        }).then((res) => {
          if (res.isConfirmed) {
            history.push(`/project/${projectId}/estimate?sow_id=${newArr[dataIndex].item[Index].sow_id}&psow_id=${newArr[dataIndex].item[Index].psow_id}`);
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Invalid input',
          text: `Accomplishment cannot be greater than the estimate measurement, ${estimateMeasurement} ${decodeURIComponent(JSON.parse(`"${unit}"`))}`,
          confirmButtonColor: '#23303D',
        });
      }
    } else if (!validateInput(value)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid input',
        text: 'Please enter a positive number',
        confirmButtonColor: '#23303D',
      });
      return;
    } else {
      updatedAccomplishment = parsedValue;
      const computationPayload = {
        accomplishment: parsedValue,
        measurement: estimateMeasurement,
      };
      const autoStatusComputation = await computeStatus(computationPayload);
      statusComputation = estimateMeasurement > 0 ? Number(autoStatusComputation)?.toFixed(2) : 0;
    }

    const updatedItem = {
      ...currentItem,
      accomplishment: updatedAccomplishment,
      accomplishment_edited: true,
      edited: true,
      status: statusComputation,
    };

    reportData.item[Index] = updatedItem;
    newArr[dataIndex] = reportData;

    if (updatedItem.accomplishment !== '') {
      setWeeklyReport(newArr);
    }
  };


  const ItemBadge = ({ underBudget, delayed, incomplete }) => {
    let badge = [];

    if (underBudget == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          WITHIN BUDGET
        </CBadge>,
      );
    } else {
      badge.push(
        <CBadge color="aimhi-danger" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          OVER BUDGET
        </CBadge>,
      );
    }

    if (incomplete == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          INCOMPLETE
        </CBadge>,
      );
    } else {
      if (delayed == 0) {
        badge.push(
          <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '3px', width: '150px' }}>
            ON-TIME
          </CBadge>,
        );
      } else {
        badge.push(
          <CBadge color="aimhi-danger" className="badge-stats" style={{ marginTop: '3px', width: '150px' }}>
            DELAYED
          </CBadge>,
        );
      }
    }

    return badge;
  };

  const WeeklyCard = isDataLoading ? (
    <Loading />
  ) : weeklyReport?.length > 0 ? (
    weeklyReport.map((data, index) => {
      let dataIndex = index;
      let ontime = true;
      const collapseCard = data.item.map((item, innerIndex) => {
        let itemStatus = item.status;
        let colorstatus = '';
        if (itemStatus >= 100) {
          colorstatus = 'green';
        } else if (itemStatus >= 1 && itemStatus <= 99) {
          colorstatus = 'blue';
        } else if (itemStatus <= 0) {
          colorstatus = 'gray';
        }
        if (item.actual_end_date > item.end_date) {
          ontime = false;
        } else {
          ontime = true;
        }

        return (
          <CCard className="shadow report-history-card" style={{ marginBottom: 0, marginLeft: '40px' }} key={innerIndex}>
            <CCardBody style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 15 }}>
              <CRow>
                <div className="float-left left-design-report"></div>
                {item.new == true ? (
                  <CCol lg="4" style={{ padding: '10px' }}>
                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Work Item / Others</span>
                    <CInput value={item.work_item} onChange={(e) => workItemChange(e, dataIndex, innerIndex)} />
                  </CCol>
                ) : (
                  <CCol
                    lg="4"
                    style={{
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'flex-end',
                      minHeight: '100%',
                    }}
                  >
                    <span className="report-label">{item.work_item}</span>
                  </CCol>
                )}

                <CCol lg="1.5" style={{ padding: '10px' }} id="Status">
                  <CCol xs="12" sm="12" md="12" lg="12" style={{ textAlign: 'center' }}>
                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Accomplishment</span>
                  </CCol>
                  <div style={{ display: 'flex', flexDirection: 'row', width: '130px' }}>
                    <CCol lg="8" md="8" sm="8" style={{ textAlign: 'center', padding: '0px 5px 0px 0px' }}>
                      <CPopover header="Measurement" content={`${item?.estimate_measurement} ${decodeURIComponent(JSON.parse(`"${item.unit}"`))}`}>
                        <CInput
                          style={{ width: '100%', height: '25px', padding: '5px', fontSize: '12px' }}
                          value={item.accomplishment}
                          type="number"
                          onChange={(e) => {
                            changeAccomplishment(e.target.value, item.estimate_measurement, item.unit, innerIndex, dataIndex);
                          }}
                          onKeyDown={preventInvalidKeys}
                          onWheel={blurOnWheel}
                          onPaste={preventInvalidPaste}
                        ></CInput>
                      </CPopover>
                    </CCol>
                    <CCol lg="4" md="4" sm="4" style={{ textAlign: 'center', padding: 0 }}>
                      <CInput style={{ width: '100%', height: '25px', padding: '5px', fontSize: '12px', textAlign: 'center' }} value={decodeURIComponent(JSON.parse(`"${item.unit}"`))} disabled></CInput>
                    </CCol>
                  </div>
                  <CCol style={{ textAlign: 'center', marginTop: '12px' }}>
                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Status</span>
                  </CCol>
                  <div className="progress-dropdown" style={{ alignContent: 'center' }}>
                    <div className="progress-dropdown" style={{ marginTop: '3px' }}>
                      <div style={{ position: 'relative' }}>
                        <CProgress style={{ height: '15px', width: '8rem' }}>
                          <div
                            id="editable"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              color: 'black',
                              fontWeight: 'bold',
                            }}
                            onDoubleClick={(e) => {
                              e.target.innerText = e.target.innerText.replace('%', '');
                              e.target.contentEditable = true;
                              e.target.focus();
                              e.target.style.paddingLeft = '1rem';
                              e.target.style.paddingRight = '1rem';
                            }}
                            onKeyDown={(e) => {
                              if (e.key == 'Enter') {
                                e.target.blur();
                              }
                            }}
                            onBlur={(e) => {
                              const newValue = parseFloat(e.target.innerText);
                              if (newValue > 100 || newValue < 0) {
                                e.target.innerText = `${itemStatus}%`;
                              } else {
                                changeSowProgress(newValue, innerIndex, dataIndex, item.estimate_measurement, item.unit);
                                e.target.innerText = `${newValue ? newValue : 0}%`;
                              }
                              e.target.contentEditable = false;
                              e.target.style.paddingLeft = '8px';
                              e.target.style.paddingRight = '8px';
                            }}
                          >
                            <span>{`${itemStatus}%`}</span>
                          </div>
                          <CProgressBar value={itemStatus} className={colorstatus + ' ' + 'select-design'} />
                        </CProgress>
                      </div>
                    </div>
                  </div>
                </CCol>

                <CCol lg="3" className="text-center">
                  <CRow>
                    <CCol className="text-center" id="Target/Actual Start">
                      <CRow style={{ paddingBottom: '10px' }}>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target Start</span>
                        </CCol>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          <DatePicker
                            className="border-2 reports"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                            value={item.start_date}
                            disabled
                            onChange={(value) => {
                              changestartdate(formatDateToMMDDYYYY(value), innerIndex, dataIndex, 'target');
                            }}
                          />
                        </CCol>

                        <CCol xs="12" sm="12" md="12" lg="12">
                          <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual Start</span>
                        </CCol>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          <DatePicker
                            className="border-2 border-black reports"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                            selected={item.actual_start_date ? new Date(item.actual_start_date) : null}
                            onChange={(value) => {
                              changestartdate(formatDateToMMDDYYYY(value), innerIndex, dataIndex, 'actual');
                            }}
                          />
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol className="text-center" id="Target/Actual End">
                      <CRow style={{ paddingBottom: '10px' }}>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          {' '}
                          <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target End</span>
                        </CCol>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          <DatePicker
                            className="border-2 reports"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                            isClearable
                            value={item.end_date}
                            disabled
                            onChange={(value) => {
                              changestartdate(formatDateToMMDDYYYY(value), innerIndex, dataIndex, 'target');
                            }}
                          />
                        </CCol>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          {' '}
                          <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual End</span>
                        </CCol>
                        <CCol xs="12" sm="12" md="12" lg="12">
                          <DatePicker
                            className="border-2 border-black reports"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                            selected={item.actual_end_date ? new Date(item.actual_end_date) : null}
                            onChange={(value) => {
                              changeenddate(formatDateToMMDDYYYY(value), innerIndex, dataIndex, 'actual');
                            }}
                          />
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol lg="2" style={{ padding: '10px' }} id="Comment/s">
                  <CCol>
                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Comment/s</span>
                  </CCol>
                  <CButton color="aimhi-textlight-neutral" size="sm" block onClick={() => openModalComment(item)}>
                    {' '}
                    View
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        );
      });
      return (
        <CCol key={index} style={{ marginTop: '20px' }}>
          <CCard style={{ marginBottom: 0 }} className="shadow" onClick={() => toggleShow(data.phase_id)}>
            <CCardBody>
              <CRow>
                <CCol lg="4">
                  <span className="float-left circle-number">
                    <span>{index + 1}</span>
                  </span>
                  <div className="report-sow-label">{data.phase}</div>
                </CCol>

                <CCol lg="2" className="align-center" style={{ marginLeft: '30px' }}>
                  <div className="circular-progress-size">
                    <CircularProgressbarWithChildren
                      className="circular-progress-size"
                      value={data.progress.toFixed(2)}
                      text={`${data.progress.toFixed(2)}%`}
                      styles={{
                        path: {
                          stroke: '#351D75',
                          strokeLinecap: 'butt',
                          transition: 'stroke-dashoffset 0.5s ease 0s',
                          transformOrigin: 'center center',
                          circleRatio: '0',
                          strokeWidth: '-10',
                        },
                        trail: {
                          stroke: '#9c9c9c',
                          strokeLinecap: 'butt',
                          transform: 'rotate(0.25turn)',
                          transformOrigin: 'center center',
                          circleRatio: '0',
                          strokeWidth: '-10',
                        },
                        text: {
                          fill: '#23303D',
                          fontSize: '20px',
                          fontWeight: '700',
                        },
                        background: {
                          fill: '#54c2a2',
                        },
                      }}
                    />
                  </div>
                  <span className="status-label align-text-mobile">Progress</span>
                </CCol>

                <CCol lg="4" xl="2">
                  <ItemBadge underBudget={data.under_budget} delayed={data.delayed} incomplete={data.incomplete} />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
          <CCol xl="12" style={{ padding: 0 }}>
            <div className={`transition-all duration-300 ${toggle.includes(data.phase_id) ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`} show={toggle.includes(data.phase_id)}>{collapseCard}</div>
          </CCol>
        </CCol>
      );
    })
  ) : (
    <CCard className="py-12 mt-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm">
      <CCardBody>
        <div className="py-4">
          <h4 className="mb-2 text-xl font-bold text-aimhi-textlight-neutral">It's empty here.</h4>
          <p className="mb-0 text-sm text-gray-500">
            There's nothing to display at the moment for the selected date range {date ? `(${date})` : ''}.
          </p>
        </div>
      </CCardBody>
    </CCard>
  );

  const handleDownload = async (project_id, type) => {
    setIsLoading(true);
    const { balance, status } = await refreshSubscription();
    const [start_date, end_date] = date.split(' - ').map((d) => d.trim());

    const proceedDownload = async () => {
      trackEvent(mixPanelEvents.DOWNLOAD_WEEKLY, {
        'Source': 'Project - Reports - Current Week',
      });
      try {
        DownloadReportWeekly(project_id, start_date, end_date, type);
        closeDialog();
      } catch (error) {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        Swal.fire({
          title: 'Oopss',
          icon: 'error',
          text: 'Something went wrong. Please try again',
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (status === 0) {
      if (balance != null && +balance < 15) return (setIsLoading(false), NoCreditsLeft());


      openDialog({
        title: 'Power Tool Feature',
        message: `You have ${balance} credits. Get unlimited Power Tools for P250/month or pay P15 per use. Once you use your credits, there’s no going back—no refunds or changes. Are you sure you want to continue? If so, how would you like to proceed?`,
        onPrimaryAction: () => proceedDownload(),
        primaryActionText: 'Pay P15',
        onSecondaryAction: () => handleSubscriptionRequest().then((res) => res === 1 && proceedDownload()).finally(() => setIsLoading(false)),
        secondaryActionText: 'Subscribe for P250',
        iconType: 'info',
        iconColor: '#3B74BE',
        onClose: () => setIsLoading(false),
      });
    } else {
      proceedDownload();
    }
  };
  return (
    <>
      <CRow>
        <CCol xs="12" style={{ marginTop: '20px' }}>
          <CRow className="mb-2 align-items-center justify-content-between flex-column flex-md-row">
            <CCol xl="8" lg="9" md="10" className="mb-2 mb-md-0">
              <CFormGroup row className="mb-0 align-items-center">
                <CLabel className="col-auto mb-0" style={{ fontWeight: 'bold' }}>Date Range</CLabel>
                <CCol xl="6" lg="6" md="6">
                  <DateRangePickerInput
                    value={date}
                    onChange={({ value: rangeStr }) => {
                      setDate(rangeStr);
                      getWeekly(0, rangeStr);
                    }}
                    disablePastDateByWeekly={true}
                    defaultToWeekToday={true}
                    maxDays={7}
                  />
                </CCol>
              </CFormGroup>
            </CCol>

            <CCol xl="4" lg="3" md="2">
              <div className="gap-2 d-flex flex-column flex-sm-row justify-content-md-end">
                {isDownloadableReportAllowed && (
                  <>
                    <CButton
                      color="aimhi-textlight-neutral"
                      variant="outline"
                      size="sm"
                      style={{ minWidth: '150px' }}
                      onClick={() => {
                        handleDownload(props.id, 1);
                      }}
                    >
                      {isLoading ? (
                        <>
                          <CSpinner color="#23303D" size="sm" />
                          <span style={{ marginLeft: '8px' }}>Download</span>
                        </>
                      ) : (
                        'Download'
                      )}
                    </CButton>
                  </>
                )}
              </div>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xs="12" md="6">
              <CButton
                color="aimhi-textlight-neutral"
                size="sm"
                onClick={saveChanges}
              >
                Save changes
              </CButton>
            </CCol>
          </CRow>

          {WeeklyCard}

          {isModalCommentOpen && (
            <ModalComments
              isModalOpen={isModalCommentOpen}
              reportData={reportData}
              onClose={closeModalComment}
              date={date}
              type={1}
            />
          )}
        </CCol>
      </CRow>
    </>
  );
};

export default Weekly;
